import { Link } from "react-router-dom/cjs/react-router-dom.min";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="error-template flex flex-col items-center justify-center gap-6">
        <h1 className="text-5xl font-bold">Oops!</h1>
        <h2 className="text-3xl mt-2 mb-4">404 - Not Found</h2>
        <p className="text-lg text-gray-400 mb-6">
          Sorry, an error has occurred. The requested page was not found!
        </p>
        <div className="error-actions mt-md-2">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-red-600 hover:bg-red-700 transition rounded text-white text-lg font-semibold"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="mr-2"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fillRule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            Take Me Home
          </Link>
        </div>
      </div>
    </div>
  );
};
export default NotFound;
